import "infinite-scroll/dist/infinite-scroll.pkgd";

let loadMore = jQuery(".load-more");

if (loadMore.length > 0) {
  let iSc = jQuery(".load-more__holder").infiniteScroll({
    path: ".load-more__button",
    checkLastPage: true,
    append: ".load-more__holder .load-more-block",
    loadOnScroll: false,
    scrollThreshold: false,
    button: ".load-more",
    status: ".page-load-status",
    debug: false,
  });
}
